<div class="container mt-3">
  <div class="row justify-content-center" *ngIf="!resetPasswordProcessing">
    <div class="col-md-8 col-lg-8">
      <div class="card">
        <div class="card-header indigo white-text">{{ Localization.ResetPassword | translate}}</div>
        <div class="card-body">
          <div class="row" [formGroup]="accountConfirmGroup">
            <div class="col-md-3 col-lg-3 label-column-text">
              <h5 class="pb-3 font-weight-bold">
                {{ Localization.NewPassword | translate}}
              </h5>
            </div>
            <div class="col-md-1 col-lg-1">
            </div>
            <div class="col-md-7 col-lg-7">
              <div class="md-form mt-3 mb-3">
                <input mdbInput type="password" id="password" maxlength="100" class="form-control validate" formControlName="password">
                <label for="password" class="ml-0" data-error="wrong" data-success="right">{{ Localization.Password | translate }}</label>
              </div>
            </div>
          </div>
          <div class="row" [formGroup]="accountConfirmGroup">
            <div class="col-md-3 col-lg-3 label-column-text">
              <h5 class="pb-3 font-weight-bold">
                {{ Localization.ConfirmPassword | translate}}
              </h5>
            </div>
            <div class="col-md-1 col-lg-1">
            </div>
            <div class="col-md-7 col-lg-7">
              <div class="md-form mt-3 mb-3">
                <input mdbInput type="password" id="passwordConfirm" maxlength="100" class="form-control validate" formControlName="passwordConfirm">
                <label for="passwordConfirm" class="ml-0" data-error="wrong" data-success="right">{{ Localization.ConfirmPassword | translate }}</label>
              </div>
            </div>
          </div>
          <div *ngIf="accountConfirmGroup.hasError('passwordToShort')" class="row justify-content-center mt-2 text-danger">
            <h5>{{ Localization.PasswordMustBeAtLeast | translate: {value: 6} }}</h5>
          </div>
          <div *ngIf="accountConfirmGroup.hasError('mismatch')" class="row justify-content-center mt-2 text-danger">
            <h5>{{ Localization.ConfirmPasswordDoesNotMatchThePassword | translate}}</h5>
          </div>
          <div class="row justify-content-center mt-3">
            <button (click)="resetPassword()" class="btn btn-amber" mdbRippleRadius [disabled]="!accountConfirmGroup.valid">
              {{ Localization.Reset | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="middle-screen-loader" *ngIf="resetPasswordProcessing">
    <mdb-spinner spinnerType="big" spinnerColor="blue"></mdb-spinner>
  </div>
</div>
